import { render, staticRenderFns } from "./thuodongGoods.vue?vue&type=template&id=15de730d"
import script from "./thuodongGoods.vue?vue&type=script&lang=js"
export * from "./thuodongGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports